import { all, fork } from 'redux-saga/effects';

import listenLoadTotals from './listenLoadTotals';
import listenLoadVehicle from './listenLoadVehicle';

export default function* vehicleSaga() {
  yield all([fork(listenLoadVehicle), fork(listenLoadTotals)]);
}
